import $ from '../$';
import ajaxSetup from '../functions/ajaxSetup';
$.ajaxSetup = ajaxSetup;
